import React from 'react';
import { motion } from 'framer-motion';
import { RadiantStar } from './ui/RadiantStar';
export function WelcomeSection() {
  return <section className="relative py-24 overflow-hidden" data-id="element-173">
      {/* Decorative Star */}
      <div className="absolute top-10 right-10 opacity-60 pointer-events-none hidden md:block" data-id="element-174">
        <RadiantStar size={48} delay={0.5} data-id="element-175" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-176">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-177">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-178">
            <h2 className="font-serif text-4xl md:text-5xl text-gold-400 mb-6" data-id="element-179">
              Welcome - This is where your next adventure begins
            </h2>

            <div className="space-y-6 text-cream-50/90 text-lg leading-relaxed" data-id="element-180">
              <p data-id="element-181">
                At Baobab Coaching, we support individuals who feel overwhelmed,
                stuck, or at a crossroads. Modern life constantly pulls our
                attention outward — deadlines, opinions, expectations, and
                endless information. We often look to others for guidance on how
                to live our lives, yet rarely take the time to reflect on what
                we truly want ourselves.
              </p>
              <p data-id="element-182">
                Our coaching slows the pace and works in partnership with you to
                reconnect with your own values and direction. Just like the
                Baobab tree draws its strength from deep roots, clarity comes
                from returning to what grounds you.
              </p>
              <p data-id="element-183">
                From this foundation, you gain clarity and make confident,
                well-considered decisions that feel natural and aligned.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-184">
            <div className="absolute inset-0 bg-gold-400/20 rounded-lg transform rotate-3" data-id="element-185"></div>
            <img src="https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?q=80&w=2074&auto=format&fit=crop" alt="Baobab tree in sunset" className="relative rounded-lg shadow-2xl w-full h-auto object-cover aspect-[4/3]" data-id="element-186" />
          </motion.div>
        </div>
      </div>
    </section>;
}